import EditItemRenderer from "./EditItemRenderer";

export default EditItemRenderer;
